<template>
  <main>
    <section class="whiteBox">
      <div class="content">
        <h1>{{$t('modifySalesChannel.title')}}</h1>
      </div>
      <hr>
      <div class="content">
        <div class="column">
          <label>{{$t('modifySalesChannel.name')}}</label>
          <div class="row">
            <input
              type="text"
              v-model="channel['name']"
            />
            <p class="tips">{{$t('modifySalesChannel.nameTips')}}</p>
          </div>
        </div>
        <div class="column">
          <label>{{$t('modifySalesChannel.merchant')}}</label>
          <div class="row">
            <input
              type="text"
              v-model="channel['merchant-name']"
            />
            <p class="tips">{{$t('modifySalesChannel.merchantTips')}}</p>
          </div>
        </div>
      </div>
      <hr>
      <div class="content">
        <button @click="update">{{$t('button.modifySalesChannel')}}</button>
        <router-link :to="{name: 'allSalesChannels'}">
          {{$t('button.cancel')}}
        </router-link>
      </div>
    </section>
  </main>
</template>

<script>
import SalesChannels from "@/services/SalesChannels.js";
export default {
  data() {
    return {
      channel: []
    };
  },
  mounted() {
    this.getSaleChannel();
  },
  methods: {
    getSaleChannel() {
      SalesChannels.getById(this.$route.params.salesChannelId).then(res => {
        this.channel = res.data;
      });
    },
    //en passant par un partial update
    update() {
      SalesChannels.partialUpdate(this.$route.params.salesChannelId, {
        name: this.channel["name"],
        "merchant-name": this.channel["merchant-name"]
      }).then(res => {
        if (res.status == 204) {
          this.$router.push({ name: "allSalesChannels" });
        }
      });
    }
  }
};
</script>